import React from 'react';
import { Star, Quote } from 'lucide-react';
import SectionHeading from './ui/SectionHeading';
import { RevealGroup, RevealItem } from './ui/Reveal';
import testimonial1 from '../assets/testimonial_1.png';
import testimonial2 from '../assets/testimonial_2.png';
import testimonial3 from '../assets/testimonial_3.png';

const testimonials = [
    {
        quote:
            'AutomateIt.ng saved our support team 20+ hours every week. The WhatsApp bot now handles 80% of inquiries automatically — our customers barely notice it isn\'t human.',
        author: 'Tunde A.',
        role: 'COO, Logistics Company',
        image: testimonial1,
    },
    {
        quote:
            'The n8n workflows they built replaced two manual roles, letting us redirect that budget straight into growth. Genuinely one of the best investments we\'ve made.',
        author: 'Sarah K.',
        role: 'Founder, E-commerce Brand',
        image: testimonial2,
    },
    {
        quote:
            'Professional, fast, and incredibly knowledgeable. They understood our complex requirements immediately and delivered ahead of schedule. Highly recommended.',
        author: 'David O.',
        role: 'Operations Manager',
        image: testimonial3,
    },
];

const Testimonials: React.FC = () => {
    return (
        <section id="testimonials" className="relative py-24 md:py-32">
            <div className="container-x">
                <SectionHeading
                    eyebrow="Testimonials"
                    title={<>Loved by teams who'd rather <span className="text-gradient">build than babysit</span></>}
                    subtitle="Don't just take our word for it — here's what founders and operators say after going live."
                />

                <RevealGroup className="mt-14 grid md:grid-cols-3 gap-5">
                    {testimonials.map((item) => (
                        <RevealItem key={item.author}>
                            <figure className="group relative h-full flex flex-col rounded-2xl card-surface p-7 hover:border-white/[0.14] transition-colors">
                                <Quote className="absolute top-6 right-6 w-10 h-10 text-white/[0.04] group-hover:text-brand-cyan/10 transition-colors" />
                                <div className="flex items-center gap-1 mb-5">
                                    {[...Array(5)].map((_, i) => (
                                        <Star key={i} className="w-4 h-4 fill-brand-orange text-brand-orange" />
                                    ))}
                                </div>
                                <blockquote className="relative flex-1 text-text-main leading-relaxed">
                                    "{item.quote}"
                                </blockquote>
                                <figcaption className="mt-6 pt-6 border-t border-white/[0.06] flex items-center gap-3">
                                    <img
                                        src={item.image}
                                        alt={item.author}
                                        loading="lazy"
                                        className="w-11 h-11 rounded-full object-cover ring-2 ring-white/10"
                                    />
                                    <div>
                                        <div className="text-white font-semibold text-sm">{item.author}</div>
                                        <div className="text-xs text-text-muted">{item.role}</div>
                                    </div>
                                </figcaption>
                            </figure>
                        </RevealItem>
                    ))}
                </RevealGroup>
            </div>
        </section>
    );
};

export default Testimonials;
